import { Api } from '../helpers';

const handoverModel = {
  getHandoverData(params) {
    const queryParams = params;
    const path = 'iva/get_handover_request_v2';
    return Api.get({ path, queryParams });
  },

  getIssueTypes(queryParams) {
    const path = 'iva/get_complaint_types';
    return Api.get({ path, queryParams });
  },

  getRefundWarnings(params) {
    const queryParams = params;
    const path = 'user/get_refund_warning';
    return Api.get({ path, queryParams });
  },

  sendHandoverAction(params, { request_id, ...data }) {
    const queryParams = params;
    const body = data;
    const path = `iva/${request_id}/submit_data`;
    return Api.put({ path, queryParams }, { body });
  },

  getAgentRequestOptions(params) {
    const queryParams = params;
    const path = 'handover/get_agent_request_options';
    return Api.get({ path, queryParams });
  },

  updateAgentRequest(data) {
    const body = data;
    const path = 'handover/update_agent_request';
    return Api.post({ path }, { body });
  },
};

export default handoverModel;
